// extracted by mini-css-extract-plugin
export default {"notification":"_2JT53nEQ6H"};
    if(module.hot) {
      // 1625219461816
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  